import styled, { css } from 'styled-components';
export var Wrapper = styled.div.withConfig({
  componentId: "sc-ro4xbn-0"
})(["height:", ";position:relative;width:100%;", ""], function (_ref) {
  var aspectRatio = _ref.aspectRatio;
  return aspectRatio ? 'auto' : '100%';
}, function (_ref2) {
  var disableInteraction = _ref2.disableInteraction;
  return disableInteraction && 'pointer-events: none;';
});
export var WistiaContainer = styled.div.withConfig({
  componentId: "sc-ro4xbn-1"
})(["position:relative;", ""], function (_ref3) {
  var aspectRatio = _ref3.aspectRatio;
  return aspectRatio && css(["display:flex;align-items:center;aspect-ratio:", ";"], aspectRatio);
});
export var WistiaThumbnailImage = styled.img.withConfig({
  componentId: "sc-ro4xbn-2"
})(["position:absolute;top:0;left:0;right:0;bottom:0;width:100%;height:auto;"]);